"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orgPersonaFactory = void 0;
const Factory = require("factory.ts");
const persona_1 = require("../../../mocks/persona");
exports.orgPersonaFactory = Factory.Sync.makeFactory({
    persona_id: Factory.each(i => i + 1),
    name: 'Org Smith',
    profile_image: persona_1.persona.profile_image,
    date_of_birth: persona_1.persona.date_of_birth,
    gender: persona_1.persona.gender,
});
